<template>
  <div class="container">
    <h1>Server Info</h1>

    <table class="version-info">
      <tbody>
        <tr>
          <th>frontend build</th>
          <td>v{{frontendBuildVersion}}</td>
        </tr>
        <tr style="color: grey;">
          <th>(min frontend required</th>
          <td>v{{minimumRequiredFrontendBuildVersion}})</td>
        </tr>
        <tr>
          <th>server build</th>
          <td>v{{serverBuildVersion}}</td>
        </tr>
      </tbody>
    </table>


    <div class="raw-data">
      <pre>{{JSON.stringify(serverInfo, null, 2)}}</pre>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import '@/date-utilities';

export default {
  name: "AdminServerInfoPage",
  data() {
    return {
      frontendBuildVersion: document?.documentElement?.dataset?.molFrontendBuildVersion,
      serverBuildVersion: null,
      minimumRequiredFrontendBuildVersion: null,
      serverInfo: {}
    }
  },
  async mounted() {
    axios.get(`/api/admin/server-info`)
        .then(response => {
          //console.log('/api/admin/server-info/ response', response);
          this.serverBuildVersion = response.headers['x-mol-server-build-version'];
          this.minimumRequiredFrontendBuildVersion = response.headers['x-mol-minimum-required-frontend-build-version'];
          this.serverInfo = response.data;
        })
        .catch((err) => {
          console.error(`error calling /api/admin/server-info : ${err}`)
        });
  },
  methods: {
  }
}
</script>


<style scoped>
.version-info {
  margin-left: 1em;
  font-style: italic;
  th {
    font-weight: inherit;
    text-align: right;
    padding-right: 0.2em;
  }
}

.raw-data {
  margin-top: 50px;
  border: solid;
  border-width: 1px;
  padding: 1em;

}
</style>